import { useTransition } from 'react';

import { Section } from '@/components/marketing/section/index.ts';
import { Button } from '@/ui/Button.tsx';

import diagramSrc from './diagram.svg';

export const DiagramSection = (props: { action: () => void }) => {
  const [isPending, startTransition] = useTransition();

  return (
    <Section.Container>
      <Section.Content className="flex flex-col items-center justify-center gap-8 py-8 md:flex-row md:gap-20">
        <div>
          <h2 className="mb-4 typography-v1-h2 text-pretty md:mb-8">
            Hvordan kredittsjekke meg selv?
          </h2>

          <p className="typography-v1-body2 text-pretty">
            Det å kredittsjekke seg selv er superenkelt, og du kan gjøre det mens du søker lån: Du
            fyller bare inn{' '}
            <button
              className="cursor-pointer text-[#18A0FB] hover:underline"
              disabled={isPending}
              onClick={() => {
                startTransition(() => {
                  props.action();
                });
              }}
            >
              opplysningene dine her
            </button>
            , logger inn med BankID – og venter. Etter kort tid får du både opp informasjonen du
            trenger for å kredittsjekke deg selv, og samtidig se hvor du får det beste lånetilbudet
            – som igjen er basert på kredittsjekken. Da får du både et innblikk i hva bankene kan se
            om deg, og du kan i fred og ro avgjøre hvilket lånetilbud du ønskerå akseptere.
          </p>

          <Button color="yellow" className="mt-10! hidden! md:block!" action={props.action}>
            Vis min kredittscore
          </Button>
        </div>

        <img src={diagramSrc} width={417} height={485} alt="kredittsjekk" />

        <Button color="yellow" className="md:hidden!" action={props.action}>
          Vis min kredittscore
        </Button>
      </Section.Content>
    </Section.Container>
  );
};
